export * from './historique-texte-dialog';